/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CompressorChannelFragment = {
	id: string;
	description: {
		constraints: {
			compressor: {
				enabled: { supported: boolean };
				ratio: { supported: boolean; range: { min: number; max: number; step: number } | null };
				threshold: { supported: boolean; range: { min: number; max: number; step: number } | null };
			} | null;
		};
		features: { compressorEngaged: { supported: boolean }; channelConfiguration: { supported: boolean } };
	};
	features: {
		name: { name: string } | null;
		compressor: { enabled: boolean | null; ratio: number | null; threshold: number | null } | null;
		channelConfiguration: { enabled: boolean } | null;
	};
};

export type CompressorChannelUpdateFragment = {
	id: string;
	features:
		| { channelConfiguration: { enabled: boolean } | null }
		| { compressor: { enabled: boolean | null; ratio: number | null; threshold: number | null } | null }
		| { name: { name: string } | null }
		| {};
};

export type CompressorChannelQueryVariables = Types.Exact<{
	channelId: Types.Scalars['ID']['input'];
}>;

export type CompressorChannelQueryOpResult = { node: CompressorChannelFragment | {} };

export type CompressorChannelSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;

export type CompressorChannelSubscriptionOpResult = {
	nodeChanges: CompressorChannelFragment | CompressorChannelUpdateFragment | {};
};

export type CompressorChannelMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type CompressorChannelMutationOpResult = {
	updateNodes: Array<{ error: { code: Types.ErrorCode; message: string } | null } | {}>;
};

export const CompressorChannelFragment = gql`
	fragment CompressorChannelFragment on AudioChannel {
		id
		description {
			constraints {
				compressor {
					enabled {
						supported
					}
					ratio {
						supported
						range {
							min
							max
							step
						}
					}
					threshold {
						range {
							min
							max
							step
						}
						supported
					}
				}
			}
			features {
				compressorEngaged {
					supported
				}
				channelConfiguration {
					supported
				}
			}
		}
		features {
			name {
				name
			}
			compressor {
				enabled
				ratio
				threshold
			}
			channelConfiguration {
				enabled
			}
		}
	}
`;
export const CompressorChannelUpdateFragment = gql`
	fragment CompressorChannelUpdateFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelNameChange {
				name {
					name
				}
			}
			... on AudioChannelCompressorChange {
				compressor {
					enabled
					ratio
					threshold
				}
			}
			... on AudioChannelChannelConfigurationChange {
				channelConfiguration {
					enabled
				}
			}
		}
	}
`;
export const CompressorChannelQueryDocument = gql`
	query CompressorChannelQuery($channelId: ID!) {
		node(id: $channelId) {
			...CompressorChannelFragment
		}
	}
	${CompressorChannelFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class CompressorChannelQueryGQL extends Apollo.Query<
	CompressorChannelQueryOpResult,
	CompressorChannelQueryVariables
> {
	override document = CompressorChannelQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const CompressorChannelSubscriptionDocument = gql`
	subscription CompressorChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
		nodeChanges(id: $id, types: $types) {
			... on AudioChannel {
				...CompressorChannelFragment
			}
			... on AudioChannelChange {
				...CompressorChannelUpdateFragment
			}
		}
	}
	${CompressorChannelFragment}
	${CompressorChannelUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class CompressorChannelSubscriptionGQL extends Apollo.Subscription<
	CompressorChannelSubscriptionOpResult,
	CompressorChannelSubscriptionVariables
> {
	override document = CompressorChannelSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const CompressorChannelMutationDocument = gql`
	mutation CompressorChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on AudioChannelOperationResult {
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class CompressorChannelMutationGQL extends Apollo.Mutation<
	CompressorChannelMutationOpResult,
	CompressorChannelMutationVariables
> {
	override document = CompressorChannelMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
